import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

export function useSubmission() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { user } = useAuth();

  const submitAnimatronic = async (data: any, mode: 'new' | 'edit') => {
    if (!user) {
      throw new Error('Must be logged in to submit');
    }

    try {
      setIsLoading(true);
      setError(null);

      if (mode === 'edit') {
        // Use media_edit_submissions table for media edits
        const { error: submitError } = await supabase
          .from('media_edit_submissions')
          .insert([{
            user_id: user.id,
            animatronic_id: data.original_animatronic_id,
            media: data.media
          }]);

        if (submitError) throw submitError;
      } else {
        // Use animatronic_submissions table for new submissions
        const { error: submitError } = await supabase
          .from('animatronic_submissions')
          .insert([{
            user_id: user.id,
            name: data.name,
            description: data.description,
            year: data.year,
            status: data.status,
            type: data.type,
            country: data.country,
            park: data.park,
            attraction: data.attraction,
            gps_coordinates: data.gps_coordinates,
            brand: data.brand,
            media: data.media
          }]);

        if (submitError) throw submitError;
      }

    } catch (err) {
      console.error('Submission error:', err);
      setError(err instanceof Error ? err : new Error('Failed to submit'));
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { submitAnimatronic, isLoading, error };
}